import { AuthenticationResult, InteractionRequiredAuthError, IPublicClientApplication } from '@azure/msal-browser';

import { HttpResource } from '@modules/core/utils';
import { msal, IS_DEV } from '@config/msalConfig';

export class HttpClient {
    static TCMS: HttpResource;
    static MOCKS: HttpResource;

    static init() {
        HttpClient.TCMS = new HttpResource(
            msal.dynamicConfig.REACT_APP_TCMS_API_URL,
            {},
            {
                getToken: IS_DEV ? null : async () => (await this.acquireTokenSilent()).accessToken
            }
        );
        HttpClient.MOCKS = new HttpResource('http://localhost:3000/api/v1/', {});
    }

    private static async acquireTokenSilent() {
        let response: AuthenticationResult;
        const instance: IPublicClientApplication = msal.instance;
        const scopes = msal.scopes;
        try {
            response = await instance.acquireTokenSilent({
                scopes,
                forceRefresh: false
            });
        } catch (error) {
            if (error instanceof InteractionRequiredAuthError) {
                try {
                    // maybe retrieval of this token requires user permission/interaction
                    await instance.acquireTokenRedirect({
                        scopes: scopes
                    });
                } catch (error) {
                    // Still an error? Do login flow again
                    await instance.loginRedirect({
                        scopes,
                        redirectUri: '/'
                    });
                }
            } else {
                // Other type of error? Do login flow again
                await instance.loginRedirect({
                    scopes,
                    redirectUri: '/'
                });
            }
        }
        return response;
    }
}
